import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  Autocomplete,
  Select,
  MenuItem,
  IconButton,
  Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText,
  Box,
  FormControl
} from "@mui/material";
import meetingServices from "services/meeting-services";
import karkunService from "services/karkun-service";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import attendanceServices from "services/attendance-services";
import { SaveButton } from "layouts/common/buttons";
import MDInput from "ui/MDInput";
import { ArrowDropDown } from "@mui/icons-material";
import fundsServices from "services/funds-services";
import MDAlert from "ui/MDAlert";
import centerService from "services/center-service";

const MarkAttendance = () => {
  const [karkuns, setKarkuns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);
  const fundsOptions = ["Name-e-Mubarak", "Sadqa", "Khairat", "Nazar"];
  const [meetings, setMeetings] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [searchDialogOpen, setSearchDialogOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredKarkuns, setFilteredKarkuns] = useState([]);
  const [centers, setCenters] = useState([]);

  const getMeetings = async () => {
    const meetingData = await meetingServices.getAll();
    if (meetingData.success && meetingData.meetings) {
      const formattedMeetings = meetingData.meetings.map(meeting => ({
        ...meeting,
        date: meeting.date ? new Date(meeting.date).toLocaleDateString("en-CA") : ""
      }));
      setMeetings(formattedMeetings);
    }
  };
  useEffect(() => {
    getMeetings();
  }, []);
  useEffect(() => {
    setAttendance((prev) => ({
      ...prev,
      fundtype: "Name-e-Mubarak",
    }));
  }, []);




  const changeHandler = async (e) => {
    const { name, value } = e.target;
    setAttendance({ ...attendance, [name]: value });

    if (name === "center") {
      await getKarkunsByCenter(value);
    }

    if (name === "karkun") {
      const selected = karkuns.find(k => k.id === value);

      setAttendance((prev) => ({
        ...prev,
        karkun: value,
        karkunId: selected?.karkunid || "",
        karkunName: selected?.name || ""
      }));

      console.log("🎯 Selected Karkun =>", selected);
    }
  };


  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);





  const getKarkunsByCenter = async (id) => {
    try {
      const getkarkunbycenterData = await karkunService.getByCenter(id);
      if (getkarkunbycenterData.success && getkarkunbycenterData.karkuns) {
        setKarkuns(getkarkunbycenterData.karkuns);   // <-- THIS
      }
    } catch (error) {
      console.error("Error fetching karkuns:", error);
    }
  };


  const [errors, setErrors] = useState({
    karkunError: false,
    amountError: false,
    fundtypeError: false,
    meetingError: false,
  });

  useEffect(() => {
    const fetchcenters = async () => {
      const response = await centerService.getAll();
      if (response.success === true && response.centers) {
        console.log('centers', response.centers);
        setCenters(response.centers);
      }
    };
    fetchcenters();

  }, []);


  const submitHandler = async (e) => {
    e.preventDefault();

    setErrors({
      karkunError: false,
      amountError: false,
      fundtypeError: false,
      meetingError: false,
    });

    if (!attendance.karkun) return setErrors((p) => ({ ...p, karkunError: true }));
    if (!attendance.meeting) return setErrors((p) => ({ ...p, meetingError: true }));
    if (!attendance.amount) return setErrors((p) => ({ ...p, amountError: true }));
    if (!attendance.fundtype) return setErrors((p) => ({ ...p, fundtypeError: true }));

    setLoading(true);

    try {

      // 👀 Yahan dekh lo exactly kya ja raha hai
      console.log("📤 ATTENDANCE DATA SENDING =>", {
        meetingId: attendance.meeting,
        karkunAttendance: [
          {
            karkunName: attendance.karkunName,
            karkunId: attendance.karkunId,
            status: "present",
          },
        ],
      });

      const attendanceRes = await attendanceServices.create({
        meetingId: attendance.meeting,
        karkunAttendance: [
          {
            karkunName: attendance.karkunName,
            karkunId: attendance.karkunId,
            status: "present",
          },
        ],
      });

      console.log("✅ Attendance Response =>", attendanceRes);

      // 👀 Fund ka bhi console
      console.log("📤 FUND DATA SENDING =>", {
        karkun: attendance.karkun,
        amount: attendance.amount,
        fundtype: attendance.fundtype,
      });

      const fundRes = await fundsServices.create({
        karkun: attendance.karkun,
        amount: attendance.amount,
        fundtype: attendance.fundtype,
      });

      console.log("✅ Fund Response =>", fundRes);

      setLoading(false);

      if (attendanceRes.success && fundRes.success) {
        setNotification({
          type: "success",
          message: "Attendance & Fund added successfully!",
        });

        setAttendance({
          fundtype: "Name-e-Mubarak",
          amount: "",
          meeting: "",
        });
      } else {
        setNotification({
          type: "error",
          message: "Something went wrong while saving!",
        });
      }
    } catch (err) {
      console.log("❌ SERVER ERROR =>", err);
      setLoading(false);
      setNotification({
        type: "error",
        message: "Server error",
      });
    }
  };




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Mark Attendance
                </MDTypography>
                <SaveButton loading={loading} onClick={submitHandler} />
              </MDBox>


              <MDBox
                component="form"
                role="form"
                display="flex"
                flexDirection="column"
                py={0}
                px={3}
              >
                {notification && (
                  <MDAlert color={notification.type} mt="20px">
                    <MDTypography variant="body2" color="white">
                      {notification.message}
                    </MDTypography>
                  </MDAlert>
                )}
                <MDBox display="flex" flexDirection="row" mt={5} mb={3}>


                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Center
                    </MDTypography>
                    <MDBox mb={1} width="100%">
                      <FormControl fullWidth error={errors.centerError}>
                        <Select
                          labelId="role-label"
                          sx={{ height: '45px' }}
                          name="center"
                          value={attendance.center || "default"}
                          onChange={changeHandler}
                          IconComponent={() => (
                            <IconButton>
                              <ArrowDropDown />
                            </IconButton>
                          )}>
                          <MenuItem disabled value="default">Select Center</MenuItem>
                          {centers.map((center) => (
                            <MenuItem key={center.centerId} value={center.id}>
                              {center.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.centerError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          The center must be selected
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Karkun
                    </MDTypography>
                    <MDBox mb={1} width="100%">
                      <FormControl fullWidth error={errors.karkunError}>
                        <Select
                          labelId="role-label"
                          sx={{ height: '45px' }}
                          name="karkun"
                          value={attendance.karkun || "default"}
                          onChange={changeHandler}
                          IconComponent={() => (
                            <IconButton>
                              <ArrowDropDown />
                            </IconButton>
                          )}>
                          <MenuItem disabled value="default">Select Karkun</MenuItem>
                          {karkuns.map((karkun) => (
                            <MenuItem key={karkun.karkunid} value={karkun.id}>
                              {karkun.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.karkunError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          The Karkun must be selected
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1}>
                      Meeting
                    </MDTypography>

                    <Autocomplete
                      options={meetings}
                      value={
                        meetings.find((m) => m.id === attendance.meeting) || null
                      }
                      getOptionLabel={(opt) =>
                        opt ? `${opt.date} - ${opt.title}` : ""
                      }
                      onChange={(e, val) =>
                        setAttendance({ ...attendance, meeting: val ? val.id : "" })
                      }
                      renderInput={(params) => (
                        <MDInput
                          {...params}
                          error={errors.meetingError}
                          placeholder="Search & Select Meeting"
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "45px",
                            },
                          }}
                        />
                      )}
                    />


                    {errors.meetingError && (
                      <MDTypography variant="caption" color="error">
                        Please select a Meeting
                      </MDTypography>
                    )}
                  </MDBox>
                </MDBox>

                <MDBox display="flex" flexDirection="row" mt={5} mb={3}>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="49%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Fund Type
                    </MDTypography>
                    <Select
                      fullWidth
                      name="fundtype"
                      value={attendance.fundtype || "Name-e-Mubarak"}
                      onChange={changeHandler}
                      displayEmpty
                      error={errors.fundtypeError}
                      sx={{
                        height: "45px",
                        "& .MuiSelect-icon": { display: "none" },
                      }}
                      IconComponent={() => (
                        <IconButton
                        >
                          <ArrowDropDown />
                        </IconButton>
                      )}
                    >
                      {fundsOptions.map((fundtype) => (
                        <MenuItem key={fundtype} value={fundtype}>
                          {fundtype}
                        </MenuItem>
                      ))}
                    </Select>

                    {errors.fundtypeError && (
                      <MDTypography variant="caption" color="error">
                        Please provide Fund Type
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Amount
                    </MDTypography>
                    <MDBox display="flex" alignItems="flex-start" width="55%">

                      <IconButton
                        onClick={() =>
                          setAttendance({
                            ...attendance,
                            amount: String(
                              Number(attendance.amount || 0) - 50
                            ),
                          })
                        }
                        sx={{
                          background: "#e0e0e0",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <ArrowDropDown style={{ transform: "rotate(90deg)" }} />
                      </IconButton>

                      <MDInput
                        type="number"
                        name="amount"
                        value={attendance.amount}
                        onChange={changeHandler}
                        fullWidth
                        sx={{
                          mx: 1,
                          "& .MuiInputBase-root": {
                            height: "45px",
                            textAlign: "center",
                          },
                        }}
                      />

                      <IconButton
                        onClick={() =>
                          setAttendance({
                            ...attendance,
                            amount: String(
                              Number(attendance.amount || 0) + 50
                            ),
                          })
                        }
                        sx={{
                          background: "#e0e0e0",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <ArrowDropDown style={{ transform: "rotate(-90deg)" }} />
                      </IconButton>
                    </MDBox>

                    {errors.amountError && (
                      <MDTypography variant="caption" color="error">
                        Please provide amount
                      </MDTypography>
                    )}

                    <MDBox display="flex" justifyContent="center" gap={2} mt={2}>
                      {[200, 300, 500, 1000, 2000].map((v) => (
                        <MDBox
                          key={v}
                          onClick={() =>
                            setAttendance({ ...attendance, amount: String(v) })
                          }
                          sx={{
                            cursor: "pointer",
                            padding: "6px 10px",
                            borderRadius: "8px",
                            background: "#f0f0f0",
                            fontWeight: 600,
                          }}
                        >
                          {v}
                        </MDBox>
                      ))}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
            <Dialog
              open={searchDialogOpen}
              onClose={() => setSearchDialogOpen(false)}
              fullWidth
              maxWidth="sm"
              PaperProps={{
                sx: {
                  borderRadius: "18px",
                  p: 0,
                  background: "rgba(255,255,255,0.6)",
                  backdropFilter: "blur(18px)",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
                  overflow: "hidden",
                },
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  p: 2.5,
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                  background: "rgba(255,255,255,0.75)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <MDTypography sx={{ fontSize: "22px", fontWeight: 700 }}>
                  🔍 Find Karkun
                </MDTypography>
                <MDTypography sx={{ fontSize: "14px", opacity: 0.7 }}>
                  Search by ID or Name – top 10 results only
                </MDTypography>
              </Box>

              {/* Search Input */}
              <Box sx={{ p: 2.5 }}>
                <MDInput
                  fullWidth
                  placeholder="Type ID or Name…"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-root": {
                      height: "50px",
                      borderRadius: "12px",
                      paddingLeft: "14px",
                      background: "rgba(255,255,255,0.9)",
                      boxShadow: "0px 3px 12px rgba(0,0,0,0.07)",
                    },
                  }}
                />
              </Box>

              {/* List */}
              <DialogContent sx={{ pt: 0, px: 2.5, pb: 3 }}>
                <List sx={{ maxHeight: "320px", overflowY: "auto" }}>
                  {filteredKarkuns.length === 0 && searchText !== "" && (
                    <MDTypography
                      sx={{
                        textAlign: "center",
                        py: 3,
                        opacity: 0.6,
                        fontSize: "15px",
                      }}
                    >
                      No matching karkun found
                    </MDTypography>
                  )}

                  {filteredKarkuns.map((k) => (
                    <ListItem
                      key={k.id}
                      onClick={() => {
                        setAttendance({
                          ...attendance,
                          karkun: k.id,
                          karkunId: k.karkunid,
                          karkunName: k.name,
                        });
                        setSearchDialogOpen(false);
                        setSearchText("");
                      }}
                      sx={{
                        mt: 0.8,
                        borderRadius: "12px",
                        px: 2,
                        py: 1.5,
                        background: "rgba(255,255,255,0.65)",
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.06)",
                        position: "relative",
                        transition: "0.2s",
                        "&:hover": {
                          background: "#e8f4ff",
                          transform: "translateY(-2px)",
                          boxShadow: "0px 5px 14px rgba(0,0,0,0.12)",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <ListItemText
                        primary={
                          <span style={{ fontWeight: 700, fontSize: "15px" }}>
                            {k.karkunid}
                          </span>
                        }
                        secondary={
                          <span style={{ fontSize: "13px", opacity: 0.75 }}>
                            {k.name}
                          </span>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default MarkAttendance;